module.exports = __webpack_public_path__ + "img/sunshine.ffe18530.png";